import Vue from 'vue'
import Vuex from 'vuex'
import request from "@/auth/request"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: {},
    currentUser:{}
  },
  mutations: {
    SET_USER: (state, user) => {
      state.user = user
    },
    SET_CURRENT_USER: (state, currentUser) => {
      state.currentUser = currentUser
    },
  },
  actions: {
    user({ commit }) {
      return new Promise((resolve, reject) => {
        request({
          url: '/v1.0/ThePublic/getUserData',
          method: 'get'
        }).then(res => {
          if (res.success) {
            commit('SET_USER', res.data)
            resolve()
          }
        }).catch(err => {
          reject(err)
        })
      })
    }
  },
  getters: {
    user: state => state.user,
    currentUser: state => state.currentUser
  },
  modules: {
  }
})
